import { render, staticRenderFns } from "./QuotationListItem.vue?vue&type=template&id=24517702&scoped=true&"
import script from "./QuotationListItem.vue?vue&type=script&lang=js&"
export * from "./QuotationListItem.vue?vue&type=script&lang=js&"
import style0 from "./QuotationListItem.vue?vue&type=style&index=0&id=24517702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24517702",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout})
